import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    dashboardLayout: {
        display: "flex",
        height: "100vh",
        overflow: "hidden",
    },
    mainColumn: {
        display: "flex",
        flexDirection: "column",
        flex: 1,
        minWidth: 0,
    },
    contentWrapper: {
        display: "flex",
        flex: 1,
        minHeight: 0,
        overflow: "auto",
        alignItems: "stretch",
    },
    container: {
        padding: `${theme.spacing(3)} ${theme.spacing(7.5)} ${theme.spacing(7.5)} ${theme.spacing(7.5)}`,
        flexGrow: 1,
        "@media (min-width: 1300px)": {
            padding: theme.spacing(7.5),
        },
    },
    gridContainer: {
        display: "flex",
        flexDirection: "column",
        height: "100%",
        rowGap: theme.spacing(2),
    },
    dropdownsRow: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
    },
    dropdowns: {
        display: "flex",
        alignItems: "flex-end",
        gap: theme.spacing(4),
    },
    graphs: {
        alignSelf: "stretch",
        flex: 1,
        minHeight: 0,
    },
    inDevelopment: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
        minHeight: 300,
    },
    inDevelopmentText: {
        "&.MuiTypography-root": {
            fontSize: "24px",
            fontWeight: 600,
            fontFamily: "Source Sans 3",
            color: "rgba(62, 93, 138, 0.4)",
            letterSpacing: "0.05em",
        },
    },
    tooltip: {
        "&.MuiTooltip-popper .MuiTooltip-tooltip": {
            backgroundColor: theme.palette.secondary.main,
        },
    },
    tooltipTexts: {
        "&.MuiTypography-root": {
            fontSize: "14px",
            textAlign: "left",
            color: theme.palette.text.primary,
            fontWeight: 600,
            fontFamily: "Source Sans 3",
            paddingBottom: "5px",
        },
    },
    fab_button: {
        position: "absolute",
        bottom: 32,
        right: 36,
    },
}));
